/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-right-4': {
    width: 9,
    height: 16,
    viewBox: '0 0 9 16',
    data: '<path d="M1 1L7.566 7.566C7.7455 7.74519 7.7455 8.03606 7.566 8.21525L1 14.7812" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
